export class MetaProduct {
  constructor(title, image, color, size, currentUrl, originPrice, originPriceCur) {
    this.title = title;
    this.image = image;
    this.color = color;
    this.size = size;
    this.currentUrl = currentUrl;
    this.originPrice = originPrice;
    this.originPriceCur = originPriceCur;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new MetaProduct(
        input[META_PRODUCT_ATTRIBUTE.TITLE],
        input[META_PRODUCT_ATTRIBUTE.IMAGE],
        input[META_PRODUCT_ATTRIBUTE.COLOR],
        input[META_PRODUCT_ATTRIBUTE.SIZE],
        input[META_PRODUCT_ATTRIBUTE.CURRENT_URL],
        input[META_PRODUCT_ATTRIBUTE.ORIGIN_PRICE],
        input[META_PRODUCT_ATTRIBUTE.ORIGIN_PRICE_CUR],
      )
    }

    return new MetaProduct();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => MetaProduct.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [MetaProduct.fromApiObject(input)];
    }

    return [];
  }
  static genParamsMeta(meta) {
    var result = {};
    if (meta.title) {
      result[META_PRODUCT_ATTRIBUTE.TITLE] = meta.title;
    }
    if (meta.image) {
      result[META_PRODUCT_ATTRIBUTE.IMAGE] = meta.image;
    }
    if (meta.color) {
      result[META_PRODUCT_ATTRIBUTE.COLOR] = meta.color;
    }
    if (meta.size) {
      result[META_PRODUCT_ATTRIBUTE.SIZE] = meta.size;
    }
    return result;
  }
}

export const META_PRODUCT_ATTRIBUTE = {
  TITLE: 'title',
  IMAGE: 'image',
  COLOR: 'color',
  SIZE: 'size',
  CURRENT_URL: 'current_url',
  ORIGIN_PRICE: 'origin_unit_price',
  ORIGIN_PRICE_CUR: 'origin_unit_price_cur',
}